import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 43"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#004EEB",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M12.5 41.5h10m-13-40h16m-8 6v-6m-16 20h32m-6 14 3 6m-23-6-3 6m6-13h.02m13.98 0h.02m-13.42 7h12.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622c.654-1.283.654-2.964.654-6.324v-8.8c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C28.94 7.5 27.26 7.5 23.9 7.5H11.1c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C1.5 12.06 1.5 13.74 1.5 17.1v8.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622c1.284.654 2.964.654 6.324.654Zm.4-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm14 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "train"}) } }